<template>
  <div>
    <auth></auth>
    <Transition name="scroll-y-reverse-transition" mode="out-in">
      <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

      <!--<v-row no-gutters>-->
      <!--auththentication!!!!!-->
      <!--<auth></auth>
        </v-row>-->
      <!-- <v-app-bar app>
      <v-toolbar-title>RPD Testing</v-toolbar-title>
      <v-btn>Email Logs</v-btn>
      <v-btn>Log Out jvonmolt</v-btn>
    </v-app-bar> -->
      <!-- top -->
      <v-main id="home-container" v-if="bshowall">
        <v-container>
          <v-row id="records_test_section1">
            <v-col cols="12" class="d-flex justify-center">
              <v-card
                elevation="2"
                outlined
                class="pl-0 pr-0 top-card secondary fixWidth_header"
              >
                <v-card-title>NIBRS Test - Section 1</v-card-title>
                <v-card-subtitle class="pb-1">
                  Please select the correct answer for each question.
                </v-card-subtitle>
                <v-card-subtitle class="d-flex pt-0 pb-1 flex-row-reverse">
                  <a class="" href="#records_test_section2">Go to Section 2</a>
                </v-card-subtitle>
                <v-card-subtitle class="d-flex pt-0 pb-1 flex-row-reverse">
                  <a class="" href="#records_test_section3">Go to Section 3</a>
                </v-card-subtitle>
                <v-card-subtitle class="d-flex pt-0 pb-1 flex-row-reverse">
                  <a class="" href="#records_test_section4">Go to Section 4</a>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>

          <v-row id="records_test_name">
            <v-col cols="12" class="d-flex justify-center">
              <v-card
                elevation="2"
                outlined
                shaped
                class="mt-1"
                style="width: 80%"
              >
                <v-container id="input-name" fluid>
                  <v-text-field
                    @change="fullname_change"
                    maxlength="120"
                    v-model="fullname"
                    label="Name"
                    required
                    :rules="nameRules"
                    placeholder="e.g. john smith"
                  >
                  </v-text-field>
                </v-container>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            id="scoreBtn1"
            class="pt-0 justify-center"
            v-if="bShowScoreBtn"
          >
            <v-col cols="4" class="d-flex justify-center">
              <v-btn @click.prevent="score_test" block label="Score This Test"
                >Score This Test</v-btn
              >
            </v-col>
          </v-row>

          <!-- SECTION 1 -->

          <section1
            :session="session"
            :sanwers1="session_n_amswrs.nbirs_recs_sanswer1"
            @update_answers="update_answers_sect1"
          >
          </section1>

          <!-- SECTION 2 Header -->
          <v-row id="records_test_section2">
            <v-col cols="12" class="d-flex justify-center">
              <v-card
                elevation="2"
                outlined
                class="mt-2 pl-0 pr-0 top-card secondary fixWidth_header"
              >
                <v-card-title>NIBRS Test - Section 2</v-card-title>
                <v-card-subtitle class="pb-1">
                  Please select the correct answer for each question.
                </v-card-subtitle>
                <v-card-subtitle class="pt-0 pb-1 d-flex flex-row-reverse">
                  <a class="temp-2-nav" href="#records_test_section1"
                    >Go to Section 1</a
                  >
                </v-card-subtitle>
                <v-card-subtitle class="pt-0 pb-1 d-flex flex-row-reverse">
                  <a class="temp-2-nav" href="#records_test_section3"
                    >Go to Section 3</a
                  >
                </v-card-subtitle>
                <v-card-subtitle class="d-flex pt-0 pb-1 flex-row-reverse">
                  <a class="" href="#records_test_section4">Go to Section 4</a>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>

          <v-row id="supp" class="pt-0">
            <v-col cols="12" class="d-flex justify-center">
              <v-card
                elevation="2"
                outlined
                class="mt-0 pl-0 pr-0 top-card secondary rounded-lg fixWidth_header"
              >
                <v-card-title>Reports with Supplements</v-card-title>
              </v-card>
            </v-col>
          </v-row>

          <section2
            :session="session"
            :sanwers2="session_n_amswrs.nbirs_recs_sanswer2"
            @update_answers="update_answers_sect2"
          ></section2>

          <v-row id="records_test_section3">
            <v-col cols="12" class="d-flex justify-center">
              <v-card
                elevation="2"
                outlined
                class="mt-2 pl-0 pr-0 top-card secondary fixWidth_header"
              >
                <v-card-title>NIBRS Test - Section 3</v-card-title>
                <v-card-subtitle class="pb-1">
                  Please select the correct answer for each question.
                </v-card-subtitle>
                <v-card-subtitle class="pt-0 pb-1 d-flex flex-row-reverse">
                  <a class="temp-2-nav" href="#records_test_section1"
                    >Go to Section 1</a
                  >
                </v-card-subtitle>
                <v-card-subtitle class="pt-0 pb-1 d-flex flex-row-reverse">
                  <a class="temp-2-nav" href="#records_test_section2"
                    >Go to Section 2</a
                  >
                </v-card-subtitle>
                <v-card-subtitle class="d-flex pt-0 pb-1 flex-row-reverse">
                  <a class="" href="#records_test_section4">Go to Section 4</a>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>

          <!-- supplement div -->

          <section3
            :session="session"
            :s3answers="session_n_amswrs.nbirs_recs_sanswer3"
            :tibQuestions="session_n_amswrs.recs_tibQuestion"
            @update_answers="update_answers_sect3"
          ></section3>
          <v-row id="records_test_section4">
            <v-col cols="12" class="d-flex justify-center">
              <v-card
                elevation="2"
                outlined
                class="mt-2 pl-0 pr-0 top-card secondary fixWidth_header"
              >
                <v-card-title>NIBRS Test - Section 4</v-card-title>
                <v-card-subtitle class="pb-1">
                  Please select the correct answer for each question.
                </v-card-subtitle>
                <v-card-subtitle class="pt-0 pb-1 d-flex flex-row-reverse">
                  <a class="temp-2-nav" href="#records_test_section1"
                    >Go to Section 1</a
                  >
                </v-card-subtitle>
                <v-card-subtitle class="pt-0 pb-1 d-flex flex-row-reverse">
                  <a class="temp-2-nav" href="#records_test_section2"
                    >Go to Section 2</a
                  >
                </v-card-subtitle>
                <v-card-subtitle class="d-flex pt-0 pb-1 flex-row-reverse">
                  <a class="" href="#records_test_section3">Go to Section 3</a>
                </v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
          <v-row id="section3-header" class="pt-0">
            <v-col cols="12" class="d-flex justify-center">
              <v-card
                elevation="2"
                outlined
                class="mt-0 pl-0 pr-0 top-card secondary rounded-lg fixWidth_header"
              >
                <v-card-title class="coding justify-center">
                  The following questions relate to proper coding of a Police
                  Report
                </v-card-title>
              </v-card>
            </v-col>
          </v-row>

          <section4
            :session="session"
            :s4answers="session_n_amswrs.nbirs_recs_sanswer4"
            @update_answers="update_answers_sect4"
            @ScoreButtonOn="ScoreButtonOn"
          ></section4>

          <v-row
            id="scoreBtn1"
            class="pt-0 justify-center"
            v-if="bShowScoreBtn"
          >
            <v-col cols="4" class="d-flex justify-center">
              <v-btn @click.prevent="score_test" block label="Score This Test"
                >Score This Test</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-main>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100%;
    max-width: 768px;
    height: auto;
    padding-top: 65px;
    margin: auto;
  }

  #home-container .v-card__subtitle {
    color: #5c5c5c;
  }

  #home-container a {
    color: #1565c0;
  }

  // #home-container a.temp-2-nav {
  //   color: aliceblue;
  // }

  .rad1 {
    background-color: white;
    height: 250px;
    width: 80%;
  }

  .alice {
    color: aliceblue;
  }

  .fixWidth {
    width: 100%;
  }

  .fixWidth_name {
    width: 94%;
  }

  .fixWidth_header {
    width: 100%;
  }

  .v-card__subtitle.reference {
    color: blue;
  }

  #s2q1 {
    height: 771px;
  }

  #s2q1 .reference img {
    width: 100%;
    height: auto;
  }

  .s2q1-width {
    max-width: 41px;
  }
  .s2q1-row-height {
    height: 36px;
  }

  .noWordWrap {
    white-space: nowrap;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }

  .fixWidth_name {
    width: 97%;
  }
}

/* ipad landscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .fixWidth {
    width: 80%;
  }

  .fixWidth_name {
    width: 78%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }

  .fixWidth {
    width: 80%;
  }

  .fixWidth_name {
    width: 78%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import section1 from "./section1.vue";
import section2 from "./section2.vue";
import section3 from "./section3.vue";
import section4 from "./section4.vue";
import auth from "./auth.vue";

//import addedit_diag from "./addedit_diag.vue";
//  const addedit_diag = () => import('./addedit_diag.vue')

export default {
  name: "Home",
  mixins: [bus_common],
  components: { section1, section2, section3, section4, auth },
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      loginURL:
        "https://rpdportal.org/?returnURL=https://nibrs-test-records.renopd.com/",
      score_percent: 0,
      score: 0,
      bad_answers: [],
      answers_key: [],
      session_n_amswrs: {},
      bshowall: false,
      bShowScoreBtn: false,
      tibQuestions: {
        cargo: "",
        hate: "",
        domViolence: "",
        location: "",
        force: "",
        attempted: "",
        nocDesc: "",
        nocCode: "",
        gang: "",
        premises: "",
        involvement: "",
      },
      q20Form: {
        weapon: "",
        domViolence: "",
        suspects: "",
        victims: "",
        attack: "",
        injury: "",
        relationship: "",
        linked: "",
      },
      current_page: {},
      bShow_dialog: false,
      fullname: "",
      radioGroup: 1,
      radios: "radio-1",
      search: "",
      pages: [
        { id: 1, pg: "0", src: "./question_images/s2q1.png" },
        { id: 2, pg: "5", src: "./question_images/s2q2.png" },
        { id: 3, pg: "8", src: "./question_images/s2q3.png" },
        { id: 4, pg: "9", src: "./question_images/s2q4.png" },
        { id: 5, pg: "9", src: "./question_images/s2q5.png" },
        { id: 6, pg: "15", src: "./question_images/s2q6.png" },
        { id: 7, pg: "15", src: "./question_images/s2q7.png" },
        { id: 8, pg: "8 & 9", src: "./question_images/s2q8.png" },
        { id: 9, pg: "8 & 9", src: "./question_images/s2q9.png" },
        { id: 10, pg: "8 & 9", src: "./question_images/s2q10.png" },
        { id: 11, pg: "8 & 9", src: "./question_images/s2q11.png" },
        {
          id: 12,
          pg: "Tiburon Screenshot",
          src: "./question_images/tiburon_screen_750.png",
        },
      ],
      myArray: { id1: 100, id2: 200, "tag with spaces": 300 },
      radio: 1,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 120 || "Name must be less than 120 characters",
      ],
    };
  },

  watch: {
    "$store.state.user": function () {
      //keep this
      this.init();
      if (this.$store.state.user.auth == true) {
        this.check_for_assignment();
      }
    },
  },
  methods: {
    ScoreButtonOn() {
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.nibrs_recs_test_sessionId = this.session.nibrs_recs_test_sessionId;
      formIn.apiname = "scorebuttonon";

      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.show_loader(false);
          //alert("data " + data);
          self.bShowScoreBtn = true;
        })
        .catch((msg) => {
          alert("err something " + msg.msg);
          self.show_loader(false);
          this.swall_it("Error", msg.msg, "error", null, null);
        });
    },
    fullname_change() {
      this.session_n_amswrs.nibrs_test_session.fullname = this.fullname;
      this.update_answers();
    },
    update_answers_sect1(sanswer1) {
      this.session_n_amswrs.nbirs_recs_sanswer1 = this.mno(sanswer1);
      this.update_answers();
    },
    update_answers_sect2(sanswer2) {
      this.session_n_amswrs.nbirs_recs_sanswer2 = this.mno(sanswer2);
      this.update_answers();
    },
    update_answers_sect3(sanswer3, recs_tibQuestion) {
      this.session_n_amswrs.nbirs_recs_sanswer3 = this.mno(sanswer3);

      this.tibQuestions.cargo = parseInt(recs_tibQuestion.cargo) || 0;
      this.tibQuestions.hate = parseInt(recs_tibQuestion.hate) || 0;
      this.tibQuestions.gang = parseInt(recs_tibQuestion.gang) || 0;
      this.tibQuestions.domViolence =
        parseInt(recs_tibQuestion.domViolence) || 0;
      this.tibQuestions.location = parseInt(recs_tibQuestion.location) || 0;
      this.tibQuestions.force = parseInt(recs_tibQuestion.force) || 0;
      this.tibQuestions.attempted = parseInt(recs_tibQuestion.attempted) || 0;
      this.tibQuestions.nocDesc = parseInt(recs_tibQuestion.nocDesc) || 0;
      this.tibQuestions.nocCode = parseInt(recs_tibQuestion.nocCode) || 0;
      this.tibQuestions.premises = parseInt(recs_tibQuestion.premises) || 0;
      this.tibQuestions.involvement =
        parseInt(recs_tibQuestion.involvement) || 0;
      this.tibQuestions.weaponType = parseInt(recs_tibQuestion.weaponType) || 0;
      this.tibQuestions.sequence = parseInt(recs_tibQuestion.sequence) || 0;
      this.tibQuestions.commission = parseInt(recs_tibQuestion.commission) || 0;
      this.tibQuestions.ibrsCode = parseInt(recs_tibQuestion.ibrsCode) || 0;

      this.session_n_amswrs.recs_tibQuestion = this.mno(this.tibQuestions);
      this.update_answers();
    },
    update_answers_sect4(sanswer4) {
      this.session_n_amswrs.nbirs_recs_sanswer4 = this.mno(sanswer4);
      this.update_answers();
    },
    update_answers() {
      //   this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.nibrs_recs_test_sessionId = this.session.nibrs_recs_test_sessionId;

      formIn.sanswer1 = this.session_n_amswrs.nbirs_recs_sanswer1;
      formIn.sanswer2 = this.session_n_amswrs.nbirs_recs_sanswer2;
      formIn.sanswer3 = this.session_n_amswrs.nbirs_recs_sanswer3;
      formIn.sanswer4 = this.session_n_amswrs.nbirs_recs_sanswer4;
      formIn.recs_tibQuestion = this.session_n_amswrs.recs_tibQuestion;
      formIn.fullname = this.session_n_amswrs.nibrs_recs_test_session.fullname;
      formIn.apiname = "update_answers";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          //  self.show_loader(false);
          //alert("data " + data);
        })
        .catch((msg) => {
          alert("err something " + msg.msg);
          self.show_loader(false);
          this.swall_it("Error", msg.msg, "error", null, null);
        });
    },
    get_answers_key() {
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_answers_key";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.answers_key = this.mno(data);
          //we loop here, and call score test but since we have answers we will not be back.
          this.score_test();
        })
        .catch((msg) => {
          alert("err something " + msg.msg);
          self.show_loader(false);
          this.swall_it("Error", msg.msg, "error", null, null);
        });
    },
    score_test() {
      if (this.answers_key.length == 0) {
        this.get_answers_key();
        return;
      }
      this.bad_answers = [];
      this.score = 0;
      let sess = this.session.nibrs_test_sessionId;

      let sanswer1 = this.session_n_amswrs.nbirs_recs_sanswer1;
      let sanswer2 = this.session_n_amswrs.nbirs_recs_sanswer2;
      let sanswer3 = this.session_n_amswrs.nbirs_recs_sanswer3;
      let sanswer4 = this.session_n_amswrs.nbirs_recs_sanswer4;
      let tibQuestions = this.session_n_amswrs.recs_tibQuestion;

      // let q17Form = this.session_n_amswrs.nbirs_records_answer_Q17Form;
      try {
        for (let index = 0; index < this.answers_key.length; index++) {
          const answer = this.answers_key[index];
          if (index == 22) {
            console.log(index);
          }
          if (answer.answer_value == sanswer1[answer.question_name_num]) {
            this.score += 1;
            continue;
          } else {
            //nothing
          }

          if (answer.answer_value == sanswer2[answer.question_name_num]) {
            this.score += 1;
            continue;
          } else {
            //nothing
          }

          if (answer.answer_value == sanswer3[answer.question_name_num]) {
            this.score += 1;
            continue;
          } else {
            //nothing
          }

          if (answer.answer_value == sanswer4[answer.question_name_num]) {
            this.score += 1;
            continue;
          } else {
            //nothing
          }

          //s3q1
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "cargo"
          ) {
            if (tibQuestions.cargo == 16) {
              this.score += 1;
              continue;
            }
          }

          //s3q1
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "force"
          ) {
            if (tibQuestions.force == 13) {
              this.score += 1;
              continue;
            }
          }

          //s3q1
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "domViolence"
          ) {
            if (tibQuestions.domViolence == 17) {
              this.score += 1;
              continue;
            }
          }

          //s3q1
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "location"
          ) {
            if (tibQuestions.location == 11) {
              this.score += 1;
              continue;
            }
          }

          //s3q1
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "attempted"
          ) {
            if (tibQuestions.attempted == 8) {
              this.score += 1;
              continue;
            }
          }

          //s3q1
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "nocDesc"
          ) {
            if (tibQuestions.nocDesc == 3) {
              this.score += 1;
              continue;
            }
          }

          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "nocCode"
          ) {
            if (tibQuestions.nocCode == 6) {
              this.score += 1;
              continue;
            }
          }

          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "premises"
          ) {
            if (tibQuestions.premises == 12) {
              this.score += 1;
              continue;
            }
          }

          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "involvement"
          ) {
            if (tibQuestions.involvement == 14) {
              this.score += 1;
              continue;
            }
          }

          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "weaponType"
          ) {
            if (tibQuestions.weaponType == 15) {
              this.score += 1;
              continue;
            }
          }

          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "sequence"
          ) {
            if (tibQuestions.sequence == 1) {
              this.score += 1;
              continue;
            }
          }

          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "commission"
          ) {
            if (tibQuestions.commission == 9) {
              this.score += 1;
              continue;
            }
          }
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "ibrsCode"
          ) {
            if (tibQuestions.ibrsCode == 7) {
              this.score += 1;
              continue;
            }
          }
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "hate"
          ) {
            if (tibQuestions.hate == 7) {
              this.score += 1;
              continue;
            }
          }
          if (
            answer.question_name_num == "s3q1" &&
            answer.answer_name == "gang"
          ) {
            if (tibQuestions.gang == 14) {
              this.score += 1;
              continue;
            }
          }

          this.bad_answers.push(answer);
        }
      } catch (error) {
        console.log(error);
      }

      var self = this;
      var pass = 0.7;
      //  var pass = 1.0;
      var qcnt = 80;
      //removed s1q17
      this.score_percent = ((this.score / qcnt) * 100).toFixed(0) + "%";
      this.score = this.score;

      if (this.score / qcnt >= pass) {
        this.swall_it(
          "Test Score",
          "Your current score is " +
            this.score +
            " out of 80. Or " +
            ((this.score / qcnt) * 100).toFixed(0) +
            "% This is a passing score. It will be recorded.  You can close this window/tab at any time." +
            " Incorrect questions are still displayed (if any) and you may choose to answer these and score the test again.",
          "success",
          function () {
            //    self.unhide_corrects_qs();
            self.hide_corrects_qs();
            self.record_score(true);
          },
          null
        );
      } else {
        this.swall_it(
          "Test Score",
          "Your current score is " +
            this.score +
            " out of 80. Or " +
            ((this.score / 80) * 100).toFixed(0) +
            "% This score does not pass.  Only incorrect questions are now displayed, correct and score the test again.",
          "success",
          function () {
            self.hide_corrects_qs();
            self.record_score(false);
          },
          null
        );
      }
    },
    unhide_corrects_qs() {
      var allqs = document.querySelectorAll(".row.pt-0");
      for (let index = 0; index < allqs.length; index++) {
        const element = allqs[index];
        if (element.id != "scoreBtn1" && element.id != "scoreBtn2") {
          element.style.display = "flex";
        }
      }
    },
    hide_corrects_qs() {
      var allqs = document.querySelectorAll(".row.pt-0");
      //hise em
      for (let index = 0; index < allqs.length; index++) {
        const element = allqs[index];
        if (element.id != "scoreBtn1" && element.id != "scoreBtn2") {
          element.style.display = "none";
        }
      }
      for (let index = 0; index < this.bad_answers.length; index++) {
        const answ = this.bad_answers[index];
        //  console.log(answ);
        let elm = document.getElementById(answ.question_name_num);
        try {
          elm.style.display = "flex";
        } catch (error) {
          console.log(" breaks: " + answ.question_name_num);
        }
      }
    },
    record_score(bpass) {
      //save the score
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.member_score = this.score_percent;
      formIn.session_score = this.score;
      formIn.bpass = bpass;
      formIn.nibrs_test_sessionId =
        this.session_n_amswrs.nibrs_recs_test_session.nibrs_recs_test_sessionId;

      formIn.apiname = "record_score";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);

          // if (bpass) {
          //   window.location.replace(self.loginURL);
          // }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    check_for_assignment() {
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "check_for_assignment";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log(data);
          if (data.msg == "false") {
            let callback = () => {
              window.location.replace(
                "https:///?returnURL=https://nibrs-test-records.renopd.com/"
              );
            };
            this.$swal({
              title: "Assignment Status",
              text:
                "A test has not been assigned to '" +
                formIn.email +
                "'. Please contact your administrator to take this test.",
              icon: "warning",
              confirmButtonText: "OK",
              confirmButtonColor: "#283593",
              timer: 6000,
              didClose: callback,
            });
            // this.swall_it(
            //   "Assignment Status",
            //   "A test has not been assigned to '" +
            //     formIn.email +
            //     ". Please contact your adminstartor to take this test.",
            //   "warning",
            //   function () {
            //     self.bshowall = false;
            //     window.location.replace(
            //       "https://rpdportal.org/rpdauth1/?returnURL=https://nibrs-test-records.renopd.com/"
            //     );
            //   },
            //   null
            // );
            return true;
          }
          self.fetch_answers();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    fetch_answers() {
      //if no answers exist this will create a new test session.
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "fetch_answers";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          console.log("fetch answer compelte");
          self.fullname = data.nibrs_recs_test_session.fullname;
          self.session = self.mno(data.nibrs_recs_test_session);
          if (self.session.scoring_on) {
            self.bShowScoreBtn = true;
          }
          self.session_n_amswrs = self.mno(data);
          //  self.tibQuestions = data.tibQuestion;
          //  self.q17Form = data.nbirs_records_answer_Q17Form;
          self.bshowall = true;
          if (data.msg == "new") {
            self.swall_it(
              "Begin Test",
              "Your test is in four sections.  Section 3 has pages from the manual you may access using the link in each question." +
                " For other questions or concerns about the test, please contact your test administrator.",
              "success",
              null,
              null
            );
          }
          if (data.msg == "old") {
            self.swall_it(
              "Continue Test",
              "Your previous answers have been loaded and can be edited if needed.",
              "success",
              null,
              null
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    /* sendRequest(rowData) {
      console.log(rowData);
    }, */
    show_dialog(page) {
      var index = this.pages.findIndex((item) => item.id === page);
      this.current_page = this.pages[index];
      this.bShow_dialog = true;
    },
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },

    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
